import { ChainId, ERC20Token, WXDAI } from '@nominex/nomiswap-sdk'
import { ERC20TokensMap } from './types'

export const tokens: ERC20TokensMap = {
  busd: new ERC20Token(
    ChainId.GNOSIS,
    '0xdd96B45877d0E8361a4DDb732da741e97f3191Ff',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/',
  ),
  nmx: new ERC20Token(
    ChainId.GNOSIS,
    '0x6Ec214fdDa5C5eD2d6CCc9Cc5BDD7F6Ef76DF6D9',
    18,
    'NMX',
    'Nominex Token',
    'https://nominex.io/',
  ),
  usdc: new ERC20Token(ChainId.GNOSIS, '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83', 6, 'USDC', 'USD Coin'),
  usdt: new ERC20Token(
    ChainId.GNOSIS,
    '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
    6,
    'USDT',
    'Tether USD',
    'https://tether.to/',
  ),
  wxdai: WXDAI[ChainId.GNOSIS],
}
